import React from "react";

function Features() {
  return (
    <div id="features">
      <h3>Some featuers should I write here, but for now this would do</h3>
      <p>Move out of here...</p>
    </div>
  );
}

export default Features;
